import { faBullhorn } from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components";
import { Component } from "react";

import { store } from "common/store";

import { NotificationPopup } from "common/features/topbar/notificationPopup";
import { Loader } from "common/helpers/HorizontalLoader";
import { references } from "common/helpers/references";
import { getAllPivotsWithValues } from "common/helpers/dimensionHelpers";

export class AnnouncementsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            indicator: false
        };
    }
    
    componentDidMount() {
        this.initializeBeamer();
    }
    
    initBeamerView = () => {
        if (window.Beamer) {
            window.Beamer.init();
        }
    };
    
    showBeamer = () => {
        if (window.Beamer) {
            setTimeout(window.Beamer.show, 0);
        }
    };
    
    initializeBeamer() {
        getAllPivotsWithValues().then((all) => {
            const packageInfo = references.toAlias(store.getState().common.merchant_config.package_ref, "package");
            window.beamer_config = {
                ...window.beamer_config,
                callback: (n) => {
                    if (n > 0) {
                        this.setState({ indicator: true });
                    }
                },
                filter: [
                    ...all.provider.map((p) => `provider-${p}`),
                    `packageName-${packageInfo.display_name}`,
                    `packagePartner-${packageInfo.partner}`,
                    `userIsAdmin-${store.getState().common.user.admin}`
                ].join(";")
            };
            this.initBeamerView();
        });
    }
    
    render() {
        return (
            <NotificationPopup
                icon={faBullhorn}
                iconStyle="announcements"
                title="Announcements"
                hasIndicator={this.state.indicator}
                onVisibilityChange={this.props.onVisibilityChange}
                onOpen={this.showBeamer}
            >
                <AnnouncementsWrapper className="beamer-announcements">
                    <AnnouncementsLoader loaded="false" />
                </AnnouncementsWrapper>
            </NotificationPopup>
        );
    }
}

const AnnouncementsWrapper = styled.div`
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    min-height: calc(100vh - 60px);
`;

const AnnouncementsLoader = styled(Loader)`
    padding-top: 10px;
    width: 100%;
    height: 500px;
`;
